export default __webpack_public_path__ + "static/media/1630.e76c1193.png";